import { sendRequest } from '../api/websocketApi';
import useStore from '../store/store';

export interface KitTypeCategory {
    KitTypeCategoryId: number;
    Name: string;
}

const GetKitTypeCategories = async () => {
    const setIsLoading = useStore.getState().setIsLoading;
    const setKitTypeCategories = useStore.getState().setKitTypeCategories;
    const setFormError = useStore.getState().setFormError;

    setIsLoading(true);
    interface APIResponse {
        success: boolean;
        kitTypeCategories?: KitTypeCategory[];
        errCode?: 'invalid_token' | 'auth_failed' | 'access_denied';
        errDetails?: string;
    }
    sendRequest(
        {
            endpoint: '/kit-type-category/get-all',
        },
        (response: APIResponse) => {
            const { success, kitTypeCategories, errCode, errDetails } =
                response;
            if (success && kitTypeCategories) {
                kitTypeCategories.sort(
                    (a, b) => a.KitTypeCategoryId - b.KitTypeCategoryId
                );
                setKitTypeCategories(kitTypeCategories);
            } else if (errCode) {
                console.error(errCode);
                setFormError(errCode);
                setTimeout(() => setFormError(errCode), 0);
                if (errDetails) console.error(errDetails);
            }
        }
    );
};

export default GetKitTypeCategories;
